import { useState, useEffect } from "react";
import GPS_IMAGE from "../../Assests/Images/Everything1.png";
import CONSULT_IMAGE from "../../Assests/Images/Everything2.png";
import CERTIFIED_IMAGE from "../../Assests/Images/Everything3.png";

// --- Icons (Styled to match your image) ---
const MapIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
  </svg>
);

const ChatIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

const BadgeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="M9 12l2 2 4-4" />
  </svg>
);

export default function CarFeatures() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Common Card Style
  const cardStyle = {
    borderRadius: "24px",
    overflow: "hidden",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    padding: isMobile ? "24px" : "32px",
    transition: "transform 0.3s ease",
    cursor: "pointer"
  };

  const iconContainerStyle = {
    width: "40px",
    height: "40px",
    borderRadius: "10px",
    background: "rgba(255, 255, 255, 0.2)",
    backdropFilter: "blur(10px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "16px",
    color: "#fff",
    border: "1px solid rgba(255,255,255,0.3)"
  };

  return (
    <section className="features-section">
      {/* Background Stroke Lines (Jesa image me hai) */}
      <div className="grid-strokes">
        <div className="v-line l-1"></div>
        <div className="v-line l-2"></div>
      </div>

      <div className="container">
        {/* Header Text */}
        <div className="features-header">
          <h2 className="title-main">
            Everything Your Car Needs, <br />
            <span className="title-light">Direction To Maintenance.</span>
          </h2>
          <p className="subtitle">
            Professional-grade care without the dealership price tag or the waiting room coffee.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="features-grid">
          
          {/* Card 1: GPS (Tall Left) */}
          <div className="card tall-card" style={cardStyle}>
            <img src={GPS_IMAGE} alt="" className="card-bg" />
            <div className="card-overlay"></div>
            <div className="card-content">
              <div style={iconContainerStyle}><MapIcon /></div>
              <h3>Precision GPS Tracking</h3>
              <p>Watch your mechanic arrive in real-time. No more "between 8AM and 4 PM" windows.</p>
            </div>
          </div>

          {/* Right Column (Stacked Cards) */}
          <div className="right-col">
            
            {/* Card 2: Consult */}
            <div className="card" style={cardStyle}>
              <img src={CONSULT_IMAGE} alt="" className="card-bg" />
              <div className="card-overlay"></div>
              <div className="card-content">
                <div style={iconContainerStyle}><ChatIcon /></div>
                <h3>Consult Before You Commit</h3>
                <p>Chat with mechanics and garage owners within a 5 km radius from home. Describe your car issue...</p>
              </div>
            </div>

            {/* Card 3: Certified Pros */}
            <div className="card" style={cardStyle}>
              <img src={CERTIFIED_IMAGE} alt="" className="card-bg" />
              <div className="card-overlay"></div>
              <div className="card-content">
                <div style={iconContainerStyle}><BadgeIcon /></div>
                <h3>Certified Pros</h3>
                <p>Every provider is background checked and ASE certified.</p>
              </div>
            </div>

          </div>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        .features-section {
          background: #ffffff;
          padding: 20px 20px;
          position: relative;
          font-family: 'Inter', sans-serif;
          overflow: hidden;
        }
        .container {
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }
        
        /* Grid Strokes (Lines) */
        .grid-strokes {
          position: absolute;
          inset: 0;
          pointer-events: none;
        }
        .v-line {
          position: absolute;
          top: 0;
          bottom: 0;
          width: 1px;
         background: rgba(255, 255, 255, 0.15)
        }
        .l-1 { left: 12%; }
        .l-2 { right: 12%; }

        /* Header Styling */
        .features-header {
          margin-bottom: 50px;
        }
        .title-main {
          font-size: clamp(30px, 4.2vw, 43px);
          font-weight: 700;
          line-height: 1.1;
          color: #000;
          letter-spacing: -0.02em;
        }
        .title-light {
          font-weight: 300;
          color: #333;
        }
        .subtitle {
          color: #666;
          
          margin-top: 15px;
          font-size: 16px;
          line-height: 1.5;
        }

        /* Grid Layout */
        .features-grid {
          display: grid;
          grid-template-columns: 1.2fr 1fr;
          gap: 16px;
        }
        .right-col {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }
        .tall-card {
          min-height: 600px;
        }
        .card {
          min-height: 292px;
        }

        /* Card Elements */
        .card-bg {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 0;
        }
        .card-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.2) 60%, transparent 100%);
          z-index: 1;
        }
        .card-content {
          position: relative;
          z-index: 2;
          color: white;
        }
        .card-content h3 {
          font-size: 20px;
          margin-bottom: 8px;
          font-weight: 600;
        }
        .card-content p {
          font-size: 14px;
          color: rgba(255,255,255,0.8);
          line-height: 1.4;
          max-width: 90%;
        }

        /* Hover Effect */
        .card:hover .card-bg {
          transform: scale(1.05);
          transition: 0.6s ease;
        }

        /* Mobile Responsive */
        @media (max-width: 991px) {
          .features-grid {
            grid-template-columns: 1fr;
          }
          .tall-card {
            min-height: 400px;
          }
          .title-main {
            font-size: 32px;
          }
          .l-1, .l-2 { display: none; }
        }
      `}} />
    </section>
  );
}